import type { ReactNode } from 'react';
import { useRouter } from './RouterContext';
import type { Route } from './types';

interface LinkProps {
  readonly to: Route;
  readonly children: ReactNode;
  readonly className?: string;
}

export function Link({ to, children, className = '' }: LinkProps) {
  const { navigate, currentRoute } = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (currentRoute !== to) {
      navigate(to);
    }
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
